import { render, staticRenderFns } from "./TipsTab.vue?vue&type=template&id=381d18d8&scoped=true&"
import script from "./TipsTab.vue?vue&type=script&lang=js&"
export * from "./TipsTab.vue?vue&type=script&lang=js&"
import style0 from "./TipsTab.vue?vue&type=style&index=0&id=381d18d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381d18d8",
  null
  
)

export default component.exports